import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { Button } from "reactstrap";

/**
 * Compact filter bar rendered inside TableContainer, right beside the
 * "Show 10" page size selector. Driven entirely by the `filters` config
 * returned from `useListFilters`.
 */

const selectStyles = (width) => ({
  container: (base) => ({ ...base, minWidth: width, maxWidth: width }),
  control: (base, state) => ({
    ...base,
    minHeight: "38px",
    borderColor: state.isFocused ? "#f9992d" : "#ced4da",
    boxShadow: state.isFocused ? "0 0 0 1px #f9992d" : "none",
    "&:hover": { borderColor: state.isFocused ? "#f9992d" : "#ced4da" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  dropdownIndicator: (base) => ({ ...base, padding: "6px" }),
  indicatorSeparator: () => ({ display: "none" }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  placeholder: (base) => ({ ...base, color: "#74788d", fontSize: "13px" }),
  singleValue: (base) => ({ ...base, fontSize: "13px" }),
  option: (base) => ({ ...base, fontSize: "13px" }),
});

const TableFilters = ({
  filters,
  filterValues,
  onFilterChange,
  onFilterReset,
  appliedFilterCount,
}) => {
  if (!filters || filters.length === 0) return null;

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {filters.map((filter) => (
        <Select
          key={filter.key}
          inputId={`filter-${filter.key}`}
          aria-label={filter.label}
          value={filterValues?.[filter.key] || null}
          onChange={(option) => onFilterChange(filter.key, option)}
          options={filter.options || []}
          placeholder={filter.label}
          classNamePrefix="select2-selection"
          isClearable
          isDisabled={filter.disabled}
          menuPortalTarget={document.body}
          maxMenuHeight={220}
          styles={selectStyles(filter.width || 170)}
          noOptionsMessage={() => "no data.."}
        />
      ))}

      {appliedFilterCount > 0 && (
        <Button
          type="button"
          color="link"
          className="p-0 text-decoration-none"
          style={{ color: "#f9992d", fontWeight: 600, whiteSpace: "nowrap" }}
          onClick={onFilterReset}
          title="Clear all filters"
        >
          <i className="mdi mdi-filter-remove-outline me-1" />
          Clear ({appliedFilterCount})
        </Button>
      )}
    </div>
  );
};

TableFilters.propTypes = {
  filters: PropTypes.array,
  filterValues: PropTypes.object,
  onFilterChange: PropTypes.func,
  onFilterReset: PropTypes.func,
  appliedFilterCount: PropTypes.number,
};

export default TableFilters;
